import React, { useEffect, useCallback } from "react";
import * as Scrivito from "scrivito";
import { Checkbox } from "components/Inputs";
import { useProjectUIActions, useShowProductPictures } from "stores/project";
import { useTranslate } from "hooks";

export const ToggleShowPictures = Scrivito.connect(() => {
  const translate = useTranslate();
  const actions = useProjectUIActions();
  const showProductPictures = useShowProductPictures();

  useEffect(() => {
    const storedValue = sessionStorage.getItem("showProductPictures");
    if (storedValue !== null) {
      actions.setShowProductPictures(storedValue === "true");
    }
  }, [actions]);

  const handleChange = useCallback(() => {
    actions.setShowProductPictures((prev) => {
      const newValue = !prev;
      sessionStorage.setItem("showProductPictures", newValue.toString());
      return newValue;
    });
  }, [actions]);

  return (
    <div className="d-flex gap-2">
      <Checkbox
        checked={showProductPictures}
        onChange={handleChange}
        wrapperClassName="cursor-pointer"
      />
      {translate("PROJECT_STRUCTURE_SHOW_PRODUCT_PICTURES")}
    </div>
  );
});
